export const charMasks: { [key: string]: number } = {
  ' ': 0b0000000,
  '': 0b0000000,
  '0': 0b0111111,
  '1': 0b0000110,
  '2': 0b1011011,
  '3': 0b1001111,
  '4': 0b1100110,
  '5': 0b1101101,
  '6': 0b1111101,
  '7': 0b0000111,
  '8': 0b1111111,
  '9': 0b1100111,
  A: 0b1110111,
  B: 0b1111111,
  C: 0b0111001,
  D: 0b0111111,
  E: 0b1111001,
  F: 0b1110001,
  G: 0b1111101,
  H: 0b1110110,
  I: 0b0000110,
  J: 0b0011110,
  K: 0b1110000,
  L: 0b0111000,
  M: 0b0110111,
  N: 0b0110111,
  O: 0b0111111,
  P: 0b1110011,
  Q: 0b0111111,
  R: 0b1110111,
  S: 0b1101101,
  T: 0b0000111,
  U: 0b0111110,
  V: 0b0111110,
  W: 0b0111110,
  X: 0b1110000,
  Y: 0b1110010,
  Z: 0b1011011,
  '-': 0b1000000,
};
